import {observer} from 'mobx-react';
import React from 'react';
import {X1LanguageSelect, X2AgeCategorySelect, X3LevelSelect} from '../../../../lib/components';
import {X3LevelStore} from '../X3LevelStore';

@observer
export class MoveUnitForm extends React.Component<{ store: X3LevelStore }> {
  render() {
    const {store} = this.props;

    if (store.move === null)
      return null;

    const move = store.move;
    return (
      <div className="row" key="move-form">
        <div className="col-3">
          <div className={move.language.formGroupClassName}>
            <X1LanguageSelect options={move.languageOptions}
                              value={move.language.value}
                              onChange={move.language.setValue}
                              onBlur={move.language.markTouched}/>
            <div className="invalid-text">Enter language</div>
          </div>
        </div>
        <div className="col-3">
          <div className={move.ageCategory.formGroupClassName}>
            <X2AgeCategorySelect options={move.ageCategoryOptions}
                                 value={move.ageCategory.value}
                                 onChange={move.ageCategory.setValue}
                                 onBlur={move.ageCategory.markTouched}/>
            <div className="invalid-text">Enter language</div>
          </div>
        </div>
        <div className="col-3">
          <div className={move.level.formGroupClassName}>
            <X3LevelSelect options={move.levelOptions}
                           value={move.level.value}
                           onChange={move.level.setValue}
                           onBlur={move.level.markTouched}/>
            <div className="invalid-text">Enter language</div>
          </div>
        </div>
      </div>
    );
  }
}
